const isRecentlyReleased = (modified) => {
    const today = new Date()
    const yesterday = new Date(today.setDate(today.getDate()-1)).toISOString();
    return modified > yesterday; 
}

export default isRecentlyReleased;